import {
  ApiData,
  SwaggerJsonFile,
  Endpoint,
} from "models/apiDocumentation/apiDocumentationModels";

export const transformSwaggerJsonFile = (
  apiSwaggerJsonFile: SwaggerJsonFile,
  noSqlApiSwaggerJsonFile: SwaggerJsonFile | null
): ApiData => {
  const mergedPaths = {
    ...apiSwaggerJsonFile.paths,
    ...(noSqlApiSwaggerJsonFile?.paths ?? {}),
  };

  const endpointList = Object.entries(mergedPaths).map(([url, path]) => {
    const getOperation = path?.get;
    return {
      url,
      summary: getOperation?.summary,
      description: getOperation?.description,
      tags: getOperation?.tags,
      deprecated: getOperation?.deprecated,
    };
  });

  const activeEndpoints = endpointList.filter(
    (endpoint) => !endpoint.deprecated
  );
  activeEndpoints.sort((a, b) => (a.summary > b.summary ? 1 : -1));

  const noSqlApiPath =
    noSqlApiSwaggerJsonFile?.paths &&
    Object.values(noSqlApiSwaggerJsonFile.paths)[0];
  const noSqlApiTag = noSqlApiPath?.get?.tags?.[0]
    ? { name: noSqlApiPath.get.tags[0], description: "" }
    : null;

  const mergedTags = [
    ...(apiSwaggerJsonFile.tags ?? []),
    ...(noSqlApiTag ? [noSqlApiTag] : []),
  ];

  const activeTags = mergedTags.filter((t) =>
    activeEndpoints.some((e) => e.tags?.includes(t.name))
  );
  activeTags.sort((a, b) => (a.name > b.name ? 1 : -1));

  return { endpoints: activeEndpoints, tags: activeTags };
};

export const getEndpointDataByPath = (
  endpoints: Endpoint[],
  path: string
): Endpoint | null =>
  endpoints.find((item) => `/endpoint${item.url}` === path) ?? null;
